<template>
  <span class="loader" :style="spinnerStyle"></span>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    size: {
      type: String,
      default: "48px",
    },
    color: {
      type: String,
      default: "#fff",
    },
    width: {
      type: String,
      default: "5px",
    },
  },
  computed: {
    spinnerStyle() {
      return {
        width: this.size,
        height: this.size,
        borderColor: this.color,
        borderBottomColor: "transparent",
        borderWidth: this.width,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
